<template>
  <el-row :gutter="20" class="search-container">
    <el-col :span="8">
      <el-form-item label="工程编号" label-width="80px" style="font-size: 15px">
        <el-input
            class="input-item"
            v-model="project_id"
            placeholder="工程id"
            clearable
        ></el-input>

      </el-form-item>
    </el-col>

    <el-col :span="8">
      <el-button
          class="confirm-button"
          type="primary"
          @click="handleConfirm"
      >
        远程查看
      </el-button>
    </el-col>
  </el-row>

</template>

<script>
import {ElMessage} from "element-plus";
import {ReplayByProjectId, syncProjectFile} from "@/components/file_process_js/main_process";

export default {
  name: 'DebugGmr',
  data() {
    return {
      project_id: "test-project",
    };
  },
  methods: {

    handleConfirm() {
      this.startParsing()
      this.$message.success('操作已确认！');
    },


    // 开始AI解析的逻辑
    startParsing() {
      if (this.project_id) {
        console.log("开始AI解析，工程编号:", this.project_id);
        this.goToResultsPage();
      } else {
        ElMessage.warning("未选择文件或文件夹")
      }
    },

    async goToResultsPage() {
      // 使用 Vuex 保存文件路径，并跳转到结果页
      this.$store.commit("setCommonObjList", []); //防止缓存，清空文件列表
      this.$store.commit("setGerberObjList", []); //防止缓存，清空文件列表
      this.$store.commit("setReadOnly", true);
      // this.$store.commit("setFilePath", this.filePath);
      this.$store.commit("clearPollingList");

      await ReplayByProjectId(this.project_id)
      this.$router.push({name: "results"});
    },
  },
};
</script>
